import Hero from './sections/hero';
// import AboutPreview from './sections/about-preview';
// import Services from './sections/services';
import WhyChooseUs from './sections/why-choose-us';
import Gallery from './sections/gallery';
import CTA from './sections/cta';
import FreeEstimates from './sections/free-estimates';
import FAB from '../../helpers/fab'

const Home = () => {
  return (
    <>
      <FreeEstimates />
      <Hero />
      <WhyChooseUs />
      <Gallery />
      {/* <AboutPreview /> */}
      {/* <Services /> */}
      <CTA />
      <FAB />
    </>
  );
};

export default Home;
